package dev.bitspittle.droidconSf24.pages.sections.kobweb.markdown

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun FrontMatterPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/markdown/FrontMatter.md", mapOf("follows" to listOf("Markdown")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("front-matter") }) {
                org.jetbrains.compose.web.dom.Text("Front Matter")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""---
root: .components.layout.ArticleLayout
author: BitSpittle
tags:
  - Web Dev
  - Tech
  - Kotlin
---
""", "text [frontmatter]")
            dev.bitspittle.droidconSf24.components.widgets.Code("""@Composable
fun ArticleLayout(content: @Composable () -> Unit) {
    val ctx = rememberPageContext()
    val markdown = ctx.markdown!!
    val author = 
        markdown.frontMatter.getValue("author").single()
    val tags =
        markdown.frontMatter.getValue("tags")
    /* ... */
}
""", "kotlin 0|3|4|5-8 <fragment>")
        }
    }
}
